export const MANAGER_ROLE = "MANAGER";
export const EMPLOYEE_ROLE = "EMPLOYEE";
